// @flow
import * as React from 'react';
import ContentLoader from 'react-content-loader';

// Components
import LoaderHOC from 'components/atoms/LoaderHOC';
import { Icon } from 'components/atoms/Icon/';
import Panel from 'components/atoms/Panel';
import {
  Row,
  Col,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  CardBody
} from 'reactstrap';
import Dropdown from 'components/atoms/Dropdown';

// Constants
import { TRANSPORTATION } from 'constants/transportation';

// Utils
import { setTransportationLabel } from 'utils/transportationLabel';

// eslint-disable-next-line import/named
import type { IntlShape } from 'react-intl';

import './AdvisorTransportationPanel.scss';

const { VALET, VALETLOANER } = TRANSPORTATION;
const ns = 'advisor-transportation-panel';

type Props = {
  advisors: Array<Object>,
  transportations: Array<Object>,
  selectedAdvisorId: number,
  setAdvisor: (advisorId: string) => Object,
  setTransportationOption: (transportation: string) => Object,
  onSelect: () => void,
  isGreeterPrefAllowed: string,
  selectedTransportation: string,
  intl: IntlShape
};

class AdvisorTransportationPanel extends React.Component<Props> {
  static defaultProps = {
    onSelect: () => {}
  };

  onAdvisorSelect = async (advisorId: string) => {
    const { setAdvisor, onSelect } = this.props;
    setAdvisor(advisorId);
    onSelect();
  };

  onTransportationSelect = async (transportation: string) => {
    const { setTransportationOption, onSelect } = this.props;
    await setTransportationOption(transportation);
    onSelect();
  };

  createDropdownMenu = (
    items: Array<Object>,
    onSelect: (data: string) => Promise<any>
  ) => {
    const { intl } = this.props;
    const dropdownItems = [];
    let i;

    for (i = 0; i < items.length; i += 1) {
      const { label, data } = items[i];
      const labelDisplayed =
        label instanceof Object ? setTransportationLabel(label, intl) : label;
      dropdownItems.push(
        <DropdownItem onClick={() => onSelect(data)} key={data}>
          {labelDisplayed}
        </DropdownItem>
      );
    }
    return <DropdownMenu>{dropdownItems}</DropdownMenu>;
  };

  createDropdown = (
    selectedItemLabel: string,
    items: Array<Object>,
    onSelect: (data: string) => Promise<any>
  ) => {
    if (items.length <= 1) {
      return (
        <span className={`${ns}__advisor-transportation-lbl`}>
          {selectedItemLabel}
        </span>
      );
    }
    return (
      <Dropdown className={`${ns}__dropdown`}>
        <DropdownToggle caret>
          {selectedItemLabel} <Icon type="chevron__down" />
        </DropdownToggle>
        {this.createDropdownMenu(items, onSelect)}
      </Dropdown>
    );
  };

  render() {
    const {
      advisors,
      selectedAdvisorId,
      isGreeterPrefAllowed,
      transportations,
      selectedTransportation,
      intl
    } = this.props;
    const selectedAdvisor = advisors.find(
      ({ data }) => data === selectedAdvisorId
    );
    const advisorSelectionEnabled = isGreeterPrefAllowed === '1';
    if (
      (!advisorSelectionEnabled && transportations.length <= 1) ||
      (!advisorSelectionEnabled &&
        (selectedTransportation === VALET ||
          selectedTransportation === VALETLOANER))
    ) {
      return null;
    }
    const selectedAdvisorLabel = selectedAdvisor && selectedAdvisor.label;
    const selectedTransportationLabel = transportations.find(
      ({ data }) => data === selectedTransportation
    );
    const transportationLabel = setTransportationLabel(
      selectedTransportationLabel ? selectedTransportationLabel.label : {},
      intl
    );
    return (
      <Panel className={ns} key={ns}>
        <CardBody>
          <Row>
            <Col>
              <div
                className={`${ns}--fit`}
                tabIndex={0}
                aria-label={intl.formatMessage({
                  id: 'c8.aria.appointment.preferences',
                  defaultMessage: 'Appointment Preferences'
                })}
              >
                {advisorSelectionEnabled ? (
                  <LoaderHOC
                    serviceId={'metaVehicle|apptOptions'}
                    placeHolderType={() => (
                      <ContentLoader height={30}>
                        <rect
                          x="0"
                          y="7"
                          className={`${ns}__placeholder-rect-title`}
                        />
                      </ContentLoader>
                    )}
                    component={() => (
                      <div>
                        <span>
                          {intl.formatMessage({
                            id: 'c8.appointment.page.advisor.selection.label'
                          })}{' '}
                        </span>
                        {this.createDropdown(
                          selectedAdvisorLabel ? selectedAdvisorLabel : '',
                          advisors,
                          this.onAdvisorSelect
                        )}
                        {selectedTransportation === VALET ||
                        selectedTransportation === VALETLOANER ? (
                          ''
                        ) : (
                          <span>
                            {intl.formatMessage({
                              id:
                                'c8.appointment.page.transportation.selection.label'
                            })}{' '}
                          </span>
                        )}
                        {selectedTransportation === VALET ||
                        selectedTransportation === VALETLOANER
                          ? ''
                          : this.createDropdown(
                              selectedTransportationLabel
                                ? transportationLabel
                                : '',
                              transportations,
                              this.onTransportationSelect
                            )}
                      </div>
                    )}
                  />
                ) : (
                  this.createDropdown(
                    selectedTransportationLabel ? transportationLabel : '',
                    transportations,
                    this.onTransportationSelect
                  )
                )}
              </div>
            </Col>
          </Row>
        </CardBody>
      </Panel>
    );
  }
}

export default AdvisorTransportationPanel;



// WEBPACK FOOTER //
// ./src/components/molecules/AdvisorTransportationPanel/AdvisorTransportationPanel.js